import MobileStepper, { MobileStepperProps } from '@mui/material/MobileStepper';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { IconButton } from '../buttons';
import { SliderDotsContainer } from './styles';
import { BoxProps } from '@mui/material';

interface Props extends BoxProps {
    activeStep: number;
    stepCount: number;
    handleNext: () => void;
    handleBack: () => void;
    stepperProps?: Partial<MobileStepperProps>;
}

export default function SliderDots({
    activeStep,
    stepCount,
    handleNext,
    handleBack,
    stepperProps,
    ...containerProps
}: Props) {
    return (
        <SliderDotsContainer {...containerProps}>
            <MobileStepper
                variant='dots'
                position='static'
                activeStep={activeStep}
                sx={{ backgroundColor: 'transparent', flexGrow: 1, gap: 2 }}
                steps={stepCount}
                {...stepperProps}
                nextButton={
                    <IconButton
                        icon={<KeyboardArrowRight />}
                        onClick={handleNext}
                        disabled={activeStep === stepCount - 1}
                    />
                }
                backButton={
                    <IconButton
                        icon={<KeyboardArrowLeft />}
                        onClick={handleBack}
                        disabled={activeStep === 0}
                    />
                }
            />
        </SliderDotsContainer>
    );
}
